const state = {
    workorderHistoryPackageDataFields: [
        {
            key: "work_code",
            label: "包裝工令單號",
            sortable: true,
        },
        {
            key: "product_code",
            label: "料號",
            sortable: true,
        },
        {
            key: "product_name",
            label: "產品說明",
            sortable: true,
        },
        {
            key: "runcard_code",
            label: "流程卡號",
            sortable: true,
        },
        {
            key: "box_qty",
            label: "回報數量(箱)",
            sortable: true,
        },
        {
            key: "start_time",
            label: "開始時間",
            sortable: true,
        },
        {
            key: "end_time",
            label: "結束時間",
            sortable: true,
        }
    ],
    workorderHistoryPackageDataItem: [],
    rowClickData: {},
    workorderHistoryTableStyle: "",
}
const getters = {
    get_workorderHistoryPackageDataFields: state => {
        return state.workorderHistoryPackageDataFields
    },
    get_workorderHistoryPackageDataItem: state => {
        return state.workorderHistoryPackageDataItem
    },
    get_rowClickData: state => {
        return state.rowClickData
    },
    get_workorderHistoryTableStyle: state => {
        return state.workorderHistoryTableStyle
    },
}
const actions = {
    set_workorderHistoryPackageDataFields(context, array) {
        context.commit('SET_WORKORDERHISTORYPACKAGEDATAFIELDS', array);
    },
    set_workorderHistoryPackageDataItem(context, array) {
        context.commit('SET_WORKORDERHISTORYPACKAGEDATAITEM', array);
    },
    set_rowClickData(context, obj) {
        context.commit('SET_ROWCLICKDATA', obj);
    },
    clear_workorderHistoryPackageDataItem(context) {
        context.commit('CLEAR_WORKORDERHISTORYPACKAGEDATAITEM');
    },
    clear_rowClickData(context) {
        context.commit('CLEAR_ROWCLICKDATA');
    },
    set_workorderHistoryTableStyle(context, string = '') {
        context.commit('SET_WORKORDERHISTORYTABLESTYLE', string);
    },
}
const mutations = {
    SET_WORKORDERHISTORYPACKAGEDATAFIELDS(state, array) {
        state.workorderHistoryPackageDataFields = array;
    },
    SET_WORKORDERHISTORYPACKAGEDATAITEM(state, array) {
        state.workorderHistoryPackageDataItem = array;
    },
    SET_ROWCLICKDATA(state, obj) {
        state.rowClickData = obj;
    },
    CLEAR_WORKORDERHISTORYPACKAGEDATAITEM(state) {
        state.workorderHistoryPackageDataItem = [];
    },
    CLEAR_ROWCLICKDATA(state) {
        state.rowClickData = {};
    },
    SET_WORKORDERHISTORYTABLESTYLE(state, string) {
        state.workorderHistoryTableStyle = string;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorderHistoryPackageData.js